import React from 'react';
import { observer, inject } from 'mobx-react'; 
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import IconAccessTime from '@material-ui/icons/AccessTime';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PersonIcon from '@material-ui/icons/Person';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Button from '@material-ui/core/Button';
import Links from '@material-ui/core/Link';
import {BrowserRouter as Router, Link} from 'react-router-dom';
//import ViewBooking from './ViewBooking'; 
import StatusColour from './StatusColour';
import Geolocation, { LiveLocationDialog } from './Geolocation';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';



const styles = theme => ({
  title: {
    marginTop: 2,
  },
  status: {
    color: 'white', 
    fontSize: 10, 
    padding: 6, 
    width: '90%', 
    textAlign: 'center', 
    borderRadius: 2,
    [theme.breakpoints.down('sm')]: {
      width: '97%',
      marginTop: '10px',
    },
  },
  bookingListItemBtn: {
    width: '85%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 0,
    [theme.breakpoints.down('sm')]: {
      // larger circular icon button on mobile
      height: 60,
      padding: 0,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
  },
  btnLabel: {
    display: 'inline',
    marginLeft: 6,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  btnMobileLabel: {
    display: 'none',
  },
  iconDesktop: {
    marginRight: 2,
    fontSize: 13,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      fontSize: 20,
    }
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      marginBottom: 8,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 16,
      '& > *': {
        marginBottom: 0,
        marginLeft: 12,
        marginRight: 12,
        width: 50,
      }
    }
  },
  infoBlock: {
    marginBottom: '5px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '10px',
    }
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


class BookingListItem extends React.Component {
  state = {
    open: this.props.expanded,
    openDriver: false,
    openCar: false,
    selectDriver: false,
    selectStatus: false,
    drivers: [],
    openLiveLocation: false,
  };

  

  UNSAFE_componentWillReceiveProps(nextProps){
    if(nextProps.expanded !== this.state.open){
      this.setState({open: nextProps.expanded });
    }
  }

  componentDidMount(){
    this.getDrivers();
  }

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  getDrivers = () => {
    fetch(this.props.appState.appRoutine.apiUrl + 'drivers/list', 
      {
      method: 'GET',
      headers: {'Content-Type': 'application/json'},
      })
      .then(res => res.json())
      .then(
        (res) => {
          if(res.result.length > 0){
            this.setState({drivers: res.result.filter(ob=>ob.STATUS === 'Active')});
          } 
        },
        (error) => {
          alert(error);
        }
      )
  }

  selectDriver=(driver)=>{
    this.setState({selectDriver: false})
    this.doUpdate(driver);
    //this.props.item.drivername = driver.NAME;
    //this.props.item.DRIVER = driver.SURNAME;
    //this.props.item.CARREG = driver.VEHICLE;
    //this.props.item.driverphoto = driver.PHOTO;
    //this.props.item.driverphone = driver.PHONE;
    //this.props.item.driverphv = driver.PHV;
    //this.props.item.STATUS = 'ALLOCATED';
    
  }

  selectStatusOption=(status)=>{
    this.setState({selectStatus: false});
    // try to find the assigned driver in the loaded drivers list
    let driverObj = this.state.drivers.find(d => d.SURNAME === this.props.item.DRIVER);
    // if not found, but the item already has DRIVER/CARREG, build a minimal driver object
    if(!driverObj && this.props.item.DRIVER){
      driverObj = { SURNAME: this.props.item.DRIVER, VEHICLE: this.props.item.CARREG };
    }
    this.doUpdate(driverObj, status);
  }

  

  doUpdate=(driver, statusOverride)=>{
    const theTransfer = {
      ID: this.props.item.ID,
      DRIVER: driver ? driver.SURNAME : '',
      SUPPLIER: 'Deluxemotion',
      CARREG: driver ? driver.VEHICLE : '',
      STATUS: statusOverride ? statusOverride : (driver ? 'ALLOCATED' : 'CONFIRMED'),
    };

    fetch(this.props.appState.appRoutine.apiUrl + 'edittransfer/jobs', 
      {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(theTransfer),
      })
      .then(res => res.json())
      .then(
        (result) => {
            this.props.appState.appRoutine.loading = false;
          if(result.status === 'err'){
            alert(result)
            console.log(result)
          }else{
            this.props.appState.appRoutine.msg = {
              text: 'Saved',
              open: true,
              type: 'success',
            };
            this.props.refresh();
          }
        },
        (error) => {
            this.props.appState.appRoutine.loading = false;
            alert(error)
            console.log(error)
        }
      )
  }

  render() {
    const { item, appState, classes} = this.props;
    const isAdmin = appState.loggedInUser && appState.loggedInUser.ROLE === 'Admin';
    const isClient = appState.loggedInUser && appState.loggedInUser.ROLE === 'Client';
    const isDriver = appState.loggedInUser && appState.loggedInUser.ROLE === 'Driver';

    return (
      <div>
        {/* Geolocation: subscribe when driver and status is IN-PROGRESS */}
          <Geolocation active={isDriver && item.STATUS === 'IN-PROGRESS'} serviceId={item.ID} />
          <ListItem button onClick={this.handleClick}>
               
               <Grid container spacing={3} >
                <Grid item xs={12} sm={12} md={2} lg={2} xl={2} style={{textAlign: 'center',}}>
                      <Typography variant="subtitle2" >{item.REF}</Typography>
                      <div className={classes.status} style={{backgroundColor: StatusColour(item.STATUS)}}>
                        {item.STATUS}
                      </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={1} xl={1}>
                    <Typography variant="caption">Time:</Typography>
                    <div style={{textAlign: 'center', display: 'flex'}}>
                      <IconAccessTime style={{fontSize: 20, color: "gray", marginTop: 4,}}/>
                      <Typography variant="subtitle1">{item.TIME}</Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12}  md={3} lg={4} xl={4}>
                    <Typography variant="caption">
                      Destination:
                    </Typography>
                    <Typography variant="subtitle2">
                      {item.FROMTITLE} {' --> '} {item.TOTITLE}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Typography variant="caption">
                      Name/Pax:
                    </Typography>
                    <Typography variant="subtitle2">{item.NAME} X {item.PAX}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <Typography variant="caption">
                      Car class:
                    </Typography>
                    <Typography variant="subtitle2">{item.CARCLASS}</Typography>
                  </Grid>
               </Grid>
               {this.state.open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            <List component="div" style={{paddingBottom: 40}}>
              <ListItem>
                <Grid container >
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <Router>
                      {//<Route path="/viewBooking" component={ViewBooking}/>
                      }
                    </Router>
                    <div className={classes.actionButtons}>
                      {(isAdmin || isClient) && (
                        <Link to={{ pathname: '/viewBooking', state: {ref: item.REF} }} onClick={()=>appState.changePage("View Booking")}> 
                          <Button size="small" color="primary" className={classes.bookingListItemBtn}>
                            <VisibilityIcon className={classes.iconDesktop} />
                            <span className={classes.btnLabel}>VIEW</span>
                            <span className={classes.btnMobileLabel}>VIEW</span>
                          </Button>
                        </Link>
                      )}
                      {isAdmin && (
                        <>
                          <Link to={{ pathname: '/editBooking', state: {id: item.ID} }} onClick={()=>appState.changePage("Edit Booking")}> 
                            <Button size="small" color="secondary" className={classes.bookingListItemBtn} >
                              <EditIcon className={classes.iconDesktop} />
                              <span className={classes.btnLabel}>EDIT</span>
                              <span className={classes.btnMobileLabel}>EDIT</span>
                            </Button>
                          </Link>
                          <Button size="small" color="primary" className={classes.bookingListItemBtn} onClick={()=>{this.setState({selectDriver: true})}}>
                            <PersonIcon className={classes.iconDesktop} />
                            <span className={classes.btnLabel}>DRIVER</span>
                            <span className={classes.btnMobileLabel}>DRIVER</span>
                          </Button>
                        </>
                      )}
                      {isDriver && (
                        <Button size="small" color="primary" className={classes.bookingListItemBtn} onClick={()=>{this.setState({selectStatus: true})}}>
                          <CheckCircle className={classes.iconDesktop} />
                          <span className={classes.btnLabel}>STATUS</span>
                          <span className={classes.btnMobileLabel}>STATUS</span>
                        </Button>
                      )}
                      {(isAdmin || item.STATUS === 'IN-PROGRESS') && (
                        <Button size="small" color="primary" className={classes.bookingListItemBtn} onClick={()=>this.setState({openLiveLocation: true})}>
                          <LocationOnIcon className={classes.iconDesktop} />
                          <span className={classes.btnLabel}>Map</span>
                          <span className={classes.btnMobileLabel}>LIVE</span>
                        </Button>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={1} xl={1}>
                    {(isAdmin || isClient) && 
                    <Typography variant="subtitle2" style={{marginLeft: 8}}>£    {item.PRICE}</Typography>
                    }
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={4} xl={4}>
                    <Typography variant="caption" >Pick-up:</Typography>
                    <Typography variant="body2" className={classes.infoBlock}>{item.FROMDETAILS}</Typography>
                    <Typography variant="caption" style={{marginTop: 5}} >Service to:</Typography>
                    <Typography variant="body2" className={classes.infoBlock}>{item.TODETAILS}</Typography>
                    {isAdmin && (
                      <>
                        <Typography variant="caption" style={{marginTop: 5}}>Notes:</Typography>
                        <Typography variant="body2" className={classes.infoBlock}>{item.NOTESS}</Typography>
                      </>
                    )}
                  </Grid> 
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  {(isAdmin || isClient) && 
                    <div>
                    <Typography variant="caption">Client:</Typography>
                    <Typography variant="body2" className={classes.infoBlock}>{item.AGENT}</Typography>
                    <Typography variant="caption" style={{marginTop: 5}} >Client's Ref:</Typography>
                    <Typography variant="body2" className={classes.infoBlock}>{item.AGENTREF}</Typography>
                    </div>
                  }
                    <Typography variant="caption" style={{marginTop: 5}} >Supplier:</Typography>
                    <Typography variant="body2" className={classes.infoBlock}>{item.SUPPLIER}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>                    
                    {item.DRIVER && 
                    <div>
                    <Typography variant="caption" style={{marginTop: 5}}>Driver:</Typography>
                    <Typography variant="subtitle2" className={classes.infoBlock}>
                      <Links component="button" variant="subtitle2" onClick={()=>{this.setState({openDriver: true})}}>{item.drivername + ' ' +  item.DRIVER}</Links>
                    </Typography>
                    <Typography variant="caption" style={{marginTop: 5}}>Vehicle:</Typography>
                    <Typography variant="subtitle2" className={classes.infoBlock}>
                      <Links component="button" variant="subtitle2" onClick={()=>{this.setState({openCar: true})}}>{item.CARREG}</Links>
                    </Typography>
                    </div>
                    }
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </Collapse>
          

          <Dialog
            open={this.state.openDriver}
            TransitionComponent={Transition}
            onClose={()=>{this.setState({openDriver: false})}}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            style={{minWidth: 200}}
          >
            <DialogTitle id="alert-dialog-slide-title">{"Driver Details"}</DialogTitle>
            <DialogContent style={{textAlign: 'center'}}>
              <DialogContentText id="alert-dialog-slide-description">
                <img 
                    src={window.location.origin + '/files/photos/' + item.driverphoto}
                    alt={this.props.appState.driver.SURNAME}
                    style={{
                        marginTop: 20,
                        width: 240,
                        borderRadius: 5,
                      }}                
                  />
              </DialogContentText>
              <div style={{minWidth: 300}}>
                  <Typography variant="body2">Name / Surname:</Typography>
                  <Typography variant="h6">{item.drivername} {item.DRIVER}</Typography>
              </div>
              <div>
                  <Typography variant="body2">Phone:</Typography>
                  <Typography variant="h6">{item.driverphone}</Typography>
              </div>
              <div>
                  <Typography variant="body2">PCO license:</Typography>
                  <Typography variant="h6">{item.driverphv}</Typography>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{this.setState({openDriver: false})}} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>     
          <LiveLocationDialog open={this.state.openLiveLocation} onClose={()=>this.setState({openLiveLocation:false})} serviceId={item.ID} />

          {/* Status selection dialog - opens when selectStatus is true */}
          <Dialog
            open={this.state.selectStatus}
            TransitionComponent={Transition}
            onClose={()=>{this.setState({selectStatus: false})}}
            aria-labelledby="alert-dialog-select-status"
            aria-describedby="alert-dialog-select-status-desc"
            fullWidth
          >
            <DialogTitle id="alert-dialog-select-status">{"Select Status"}</DialogTitle>
            <DialogContent dividers>
              <List>
                {['ACCEPTED','IN-PROGRESS','COMPLETED'].map((st, idx)=> (
                  <ListItem button key={idx} onClick={()=>{this.selectStatusOption(st)}}>
                    <ListItemText primary={st} />
                  </ListItem>
                ))}
              </List>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{this.setState({selectStatus: false})}} color="primary">Close</Button>
            </DialogActions>
          </Dialog>


          <Dialog
            open={this.state.openCar}
            TransitionComponent={Transition}
            onClose={()=>{this.setState({openCar: false})}}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{"Vehicle Details"}</DialogTitle>
            <DialogContent style={{textAlign: 'center'}}>
              <div style={{minWidth: 300}}>
                  <Typography variant="body2">Vehicle:</Typography>
                  <Typography variant="h6">{item.CARCLASS}</Typography>
                  <Typography variant="body2">Reg. no:</Typography>
                  <Typography variant="h6">{item.CARREG}</Typography>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{this.setState({openCar: false})}} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>         


          <Dialog
            open={this.state.selectDriver}
            TransitionComponent={Transition}
            fullWidth
            onClose={()=>{this.setState({selectDriver: false})}}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{"Select Driver"}</DialogTitle>
            <DialogContent dividers style={{textAlign: 'center'}}>
              <List component="nav" className={classes.list}>
              {
                this.state.drivers.map((item, index)=>
                <ListItem button key={index} onClick={() => {this.selectDriver(item)}}>
                  <ListItemText primary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body1"
                        className={classes.inline}
                        color={item.STATUS==='Active'? 'textPrimary': 'textSecondary'}
                      >
                        {item.NAME + ' ' + item.SURNAME}
                      </Typography>
                      </React.Fragment>
                      }
                      secondary={item.VEHICLE}
                    />
                </ListItem>
                )
              }
              </List>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{this.setState({selectDriver: false}); this.selectDriver()}} color="primary">
                Clear
              </Button>
              <Button onClick={()=>{this.setState({selectDriver: false})}} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>  
      </div>
    );
  }
}

BookingListItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(inject('appState')(observer(BookingListItem)));